// src/styles/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,800;1,400;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    background-color: ${({ theme }) => theme.colors.bgPrimary};
    color: ${({ theme }) => theme.colors.textPrimary};
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: ${({ theme }) => theme.fontSizes.base};
    line-height: ${({ theme }) => theme.lineHeights.normal};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
  }

  ul, ol {
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.display};
    line-height: ${({ theme }) => theme.lineHeights.tight};
  }

  ::selection {
    background: rgba(201, 146, 42, 0.3);
    color: #fff;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.bgPrimary};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.goldDark};
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.gold};
  }

  /* React Select global overrides */
  .react-select__control {
    background: ${({ theme }) => theme.colors.bgCard} !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: ${({ theme }) => theme.borderRadius.md} !important;
    color: ${({ theme }) => theme.colors.textPrimary} !important;
    min-height: 48px !important;
    box-shadow: none !important;

    &:hover {
      border-color: ${({ theme }) => theme.colors.gold} !important;
    }
  }

  .react-select__control--is-focused {
    border-color: ${({ theme }) => theme.colors.gold} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.goldMuted} !important;
  }

  .react-select__menu {
    background: ${({ theme }) => theme.colors.bgCard} !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: ${({ theme }) => theme.borderRadius.md} !important;
    box-shadow: ${({ theme }) => theme.shadows.lg} !important;
  }

  .react-select__option {
    color: ${({ theme }) => theme.colors.textSecondary} !important;
    background: transparent !important;

    &:hover {
      background: ${({ theme }) => theme.colors.goldMuted} !important;
      color: ${({ theme }) => theme.colors.textPrimary} !important;
    }
  }

  .react-select__option--is-selected {
    background: ${({ theme }) => theme.colors.goldMuted} !important;
    color: ${({ theme }) => theme.colors.gold} !important;
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.colors.textPrimary} !important;
  }

  .react-select__placeholder {
    color: ${({ theme }) => theme.colors.textMuted} !important;
  }

  .react-select__input-container {
    color: ${({ theme }) => theme.colors.textPrimary} !important;
  }

  .react-select__indicator-separator {
    background: ${({ theme }) => theme.colors.border} !important;
  }

  .react-select__dropdown-indicator {
    color: ${({ theme }) => theme.colors.textMuted} !important;
  }

  .react-select__clear-indicator {
    color: ${({ theme }) => theme.colors.textMuted} !important;
    &:hover {
      color: ${({ theme }) => theme.colors.gold} !important;
    }
  }
`;

export default GlobalStyles;
